import React from 'react';

import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Alert from '@amzn/meridian/alert';
import Link from '@amzn/meridian/link';
import Text from '@amzn/meridian/text';
import { useQuery } from '@tanstack/react-query';
import { ASSOCIATE_PROFILE_BASEURL } from 'src/constants/Routes';
import { getAssociateProfileQueryOptions } from 'src/services/associateProfile/associateProfileQueries';
import { useAppSelector } from 'src/store/store';
import { JmrFlowTypes } from 'src/utils/jmrUtils';

const PlacementCountAlert = () => {
  const { jmrFlowType, backgroundFormData } = useAppSelector((state) => state.newJmrPage);

  const placementsQuery = useQuery(
    getAssociateProfileQueryOptions.placements(backgroundFormData.alias, backgroundFormData.site.id),
  );

  const placementCount = placementsQuery.data
    ? placementsQuery.data.pending.length +
      placementsQuery.data.active.length +
      placementsQuery.data.transferredIn.length
    : 0;

  const activePlacementCount =
    jmrFlowType === JmrFlowTypes.CreateNewAccommodation ? placementCount : placementCount - 1;

  if (activePlacementCount <= 0) return null;

  return (
    <Alert type="theme" iconTokens={infoKnockoutTokens}>
      <Text type="b200">
        <b>{activePlacementCount} Active Placements.</b>&nbsp;
        <Link
          href={`${ASSOCIATE_PROFILE_BASEURL}/${backgroundFormData.alias}/restrictions?site=${backgroundFormData.site.site}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          See details
        </Link>
      </Text>
    </Alert>
  );
};

export default PlacementCountAlert;
